/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type DeleteMcpCredentialRequest = {
  credentialId: string;
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
};

/** @internal */
export const DeleteMcpCredentialRequest$inboundSchema: z.ZodType<
  DeleteMcpCredentialRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  credential_id: z.string(),
  "X-On-Behalf-Of": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "credential_id": "credentialId",
    "X-On-Behalf-Of": "xOnBehalfOf",
  });
});
/** @internal */
export type DeleteMcpCredentialRequest$Outbound = {
  credential_id: string;
  "X-On-Behalf-Of"?: string | undefined;
};

/** @internal */
export const DeleteMcpCredentialRequest$outboundSchema: z.ZodType<
  DeleteMcpCredentialRequest$Outbound,
  z.ZodTypeDef,
  DeleteMcpCredentialRequest
> = z.object({
  credentialId: z.string(),
  xOnBehalfOf: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    credentialId: "credential_id",
    xOnBehalfOf: "X-On-Behalf-Of",
  });
});

export function deleteMcpCredentialRequestToJSON(
  deleteMcpCredentialRequest: DeleteMcpCredentialRequest,
): string {
  return JSON.stringify(
    DeleteMcpCredentialRequest$outboundSchema.parse(deleteMcpCredentialRequest),
  );
}
export function deleteMcpCredentialRequestFromJSON(
  jsonString: string,
): SafeParseResult<DeleteMcpCredentialRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DeleteMcpCredentialRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DeleteMcpCredentialRequest' from JSON`,
  );
}
